(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mb-review-display"] && !Shopify.designMode) return;
  try {
    (() => {
  const mounted = new WeakSet();
  const pathOf = (url) => url.pathname.replace(/\/+$/, '');
  function mountProductPhotos() {
    const config = document.getElementById('mb-review-product-photo');
    if (!config) return;
    const productUrl = new URL(config.dataset.productUrl, window.location.href);
    const shopUrl = new URL(config.dataset.shopUrl, window.location.href);
    const allowedOrigins = new Set([window.location.origin, shopUrl.origin]);
    const photoUrl = new URL(config.dataset.photoUrl, window.location.href);
    const captionText = config.dataset.caption;
    const productTitle = config.dataset.productTitle;
    function updatePhotos(root) {
      root.querySelectorAll('.trustap-full-review__review-image img').forEach((img) => {
        if (img.dataset.mbProductPhoto === 'true') return;
        let source;
        try {
          source = new URL(img.getAttribute('src'), window.location.href);
        } catch {
          return;
        }
        if (!allowedOrigins.has(source.origin) || pathOf(source) !== pathOf(productUrl)) return;
        const container = img.closest('.trustap-full-review__review-image');
        img.dataset.mbProductPhoto = 'true';
        img.alt = productTitle + ' — ' + captionText;
        img.addEventListener('error', () => { container.hidden = true; }, { once: true });
        img.src = photoUrl.href;
        const caption = document.createElement('p');
        caption.className = 'mb-review-product-photo__caption';
        caption.textContent = captionText;
        container.append(caption);
      });
    }
    document.querySelectorAll('.trustap-full-review').forEach((root) => {
      if (mounted.has(root)) return;
      mounted.add(root);
      updatePhotos(root);
      new MutationObserver(() => updatePhotos(root)).observe(root, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountProductPhotos, { once: true });
  } else {
    mountProductPhotos();
  }
  document.addEventListener('shopify:section:load', mountProductPhotos);
})();
  } catch(e) { console.error(e); }
})();

})();
